import React, { useEffect } from 'react';
import { Card, Typography, Space, Divider } from 'antd';
import { MailOutlined, QuestionCircleOutlined, TeamOutlined, SoundOutlined, UserOutlined } from '@ant-design/icons';
import './aboutme.css';
import activityTracker from '../user/ActivityTracker';
import usePageTracking from '../utils/usePageTracking';

const { Title, Paragraph, Text } = Typography;

function AboutMe() {
  // GA4 页面追踪
  usePageTracking('關於我們');
  
  useEffect(() => {
    activityTracker.trackPageView('about_me');
  }, []);

  return (
    <div className="about-me-container">
      <Card className="about-me-card">
        <Space direction="vertical" size="large" style={{ width: '100%' }}>
          <div className="section">
            <Title level={2}>
              <QuestionCircleOutlined /> 關於 DeepBuffett
            </Title>
            <Paragraph>
              DeepBuffett 是一個專注於美股分析的智能平台，我們致力於為投資者提供專業、準確的財報分析和市場洞察。
              通過 AI 技術，我們將複雜的財務數據轉化為易於理解的投資建議，幫助投資者做出更明智的投資決策。
            </Paragraph>
          </div>

          <Divider style={{ margin: '1px 0' }} />

          <div className="section">
            <Title level={3}>
              <UserOutlined /> 創辦人介紹
            </Title>
            <Paragraph>
              <Text strong style={{ fontSize: '16px', color: '#1890ff' }}>科技巴菲特創辦人 - 比特先生</Text>
            </Paragraph>
            <Paragraph>
              <ul style={{ lineHeight: '2' }}>
                <li><Text strong>2007年</Text> 開始投資</li>
                <li><Text strong>2016年</Text> 成為破產的散戶工程師</li>
                <li><Text strong>2021年</Text> 財富自由，脫離職場</li>
                <li><Text strong>2024年</Text> 突破億元資產</li>
              </ul>
            </Paragraph>
            <Paragraph>
              擁有 <Text strong>20年的投資資歷</Text>，涉足台股、美股、加密貨幣等領域，曾擔任 BYUMS 投資理財講師。
            </Paragraph>
            <Paragraph>
              <Text strong>投資專長：</Text>逆勢交易、價值成長投資領域
            </Paragraph>
          </div>

          <Divider style={{ margin: '1px 0' }} />

          <div className="section">
            <Title level={3}>
              <TeamOutlined /> 我們的服務
            </Title>
            <Paragraph>
              <ul>
                <li>AI 驅動的財報分析</li>
                <li>即時財務數據更新</li>
                <li>專業的市場洞察報告</li>
                <li>個股深度研究</li>
                <li>產業趨勢分析</li>
              </ul>
            </Paragraph>
          </div>

          <Divider style={{ margin: '1px 0' }} />

          <div className="section">
            <Title level={3}>
              <SoundOutlined /> Podcast 最新時事
            </Title>
            <Paragraph>
              收聽「科技巴菲特 - 15分鐘給你最新產業個股分析」，獲取即時最新最熱門的美股產業深層分析，並分享華爾街分析師們的即時見解。
              <br />
              <br />
              <Text strong>Podcast 連結：</Text>
              <a 
                href="https://deepbuffett.firstory.io/episodes" 
                target="_blank" 
                rel="noopener noreferrer"
                style={{ marginLeft: '8px' }}
              >
                https://deepbuffett.firstory.io/episodes
              </a>
            </Paragraph>
            <Paragraph>
              每集15分鐘，深入淺出分析美股投資機會，涵蓋投資觀念、美股分析與巴菲特投資哲學。
            </Paragraph>
          </div>

          <Divider style={{ margin: '1px 0' }} />

          <div className="section">
            <Title level={3}>
              <MailOutlined /> 聯繫我們
            </Title>
            <Paragraph>
              如果您在系統操作上有任何問題、系統功能上的建議，歡迎隨時寫信給我
              您的任何問題都將由科技巴菲特的創辦人親自回覆
              <br />
              <Text strong>Email：</Text>
              <a href="mailto:peterchiang@deepbuffett.com">peterchiang@deepbuffett.com</a>
            </Paragraph>
            <Paragraph>
              我們會盡快回覆您的郵件，並為您提供專業的解答和服務。
            </Paragraph>
          </div>
        </Space>
      </Card>
    </div>
  );
}

export default AboutMe; 